/**
 * Note, max width is set to none. We still have this config theme variable in case it should come back.
 */

const maxWidth = 'none';
export default maxWidth;
